import React from "react";
import PropTypes from "prop-types";
import { TextWrapper, Wrapper, CustomizedWrapper } from "./AdditionalService";
import { useSelector } from "react-redux";
import { getPendoId } from "../../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../../constants/appConstants";

const { TABLET } = DEVICE_BREAKPOINTS;

function AddAnotherService(props) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);

  //On keyboard accessible to select the option - "I want to transfer a device" or "I want to remove a device"
  const keyPressSelect = (e, val) => {
    if (e.key === "Enter" || e.key === " ") {
      props.handleAnotherService(val);
    }
  };

  return (
    <>
      {props.isAddAnotherService ? (
        <>
          <TextWrapper
            aria-label={"Add another service"}
            role="heading"
            fontSize="1.5rem"
            fontWeight="700"
            lineHeight="2rem"
            margin={windowSize.width < TABLET ? "1.5rem 0 0 0" : "2rem 0 0 0"}
          >
            {props.serviceDetails.length > 0 ? `Add another service` : `Add a service`}
          </TextWrapper>
          <Wrapper
            borderRadius="0.5rem"
            width={"100%"}
            flexDirection={windowSize.width < TABLET ? "column" : "row"}
            justifyContent="space-between"
            alignItems="flex-start"
            gap={windowSize.width < TABLET ? "1rem" : "1.5rem"}
            marginTop={"1rem"}
          >
            <CustomizedWrapper
              tabIndex={0}
              role="button"
              gap="0.5rem"
              flexDirection={"column"}
              justifyContent="flex-start"
              alignItems="flex-start"
              alignSelf="stretch"
              borderRadius="0.5rem"
              background="#F6F6F6"
              padding={"1.5rem"}
              cursor="pointer"
              id={getPendoId("add-another-transfer")}
              onClick={() => {
                props.handleAnotherService(1);
              }}
              onKeyDown={(e) => keyPressSelect(e, 1)}
            >
              <TextWrapper aria-label="I want to transfer a device" fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem" margin="0 1.5rem 0 0">
                I want to transfer a device
              </TextWrapper>
              <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0 1.5rem 0 0">
                If you’re looking for technician to transfer a device from one vehicle or asset to another.
              </TextWrapper>
            </CustomizedWrapper>
            <CustomizedWrapper
              tabIndex={0}
              role="button"
              gap="0.5rem"
              flexDirection={"column"}
              justifyContent="flex-start"
              alignItems="flex-start"
              alignSelf="stretch"
              borderRadius="0.5rem"
              background="#F6F6F6"
              padding={windowSize.width < TABLET ? "1rem" : "1.5rem"}
              cursor="pointer"
              id={getPendoId("add-another-removal")}
              onClick={() => {
                props.handleAnotherService(2);
              }}
              onKeyDown={(e) => keyPressSelect(e, 2)}
            >
              <TextWrapper aria-label="I want to remove a device" fontSize="1.25rem" fontWeight="700" lineHeight="1.5rem" margin="0 1.5rem 0 0">
                I want to remove a device
              </TextWrapper>
              <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" margin="0 1.5rem 0 0">
                If you’re looking for technician to remove a device from the current vehicle or asset.
              </TextWrapper>
            </CustomizedWrapper>
          </Wrapper>
        </>
      ) : (
        props.handleVehicleAssetDetails(props.serviceDetails.length)
      )}
    </>
  );
};

AddAnotherService.propTypes = {
  handleAnotherService: PropTypes.func.isRequired,
  handleVehicleAssetDetails: PropTypes.func.isRequired,
  isAddAnotherService: PropTypes.bool.isRequired,
  serviceDetails: PropTypes.array.isRequired,
};

export default AddAnotherService;